import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const LastPageContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${vimovaTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${vimovaTheme.colors.primary};
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    background-color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OrangeBracketDecoration = styled.div`
  position: absolute;
  top: 40px;
  left: 40px;
  opacity: 0.4;

  @media print {
    position: absolute !important;
    top: 40px !important;
    left: 40px !important;
    opacity: 0.4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 140px 48px 48px 48px;
  position: relative;
  z-index: 1;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 140px 48px 48px 48px !important;
  }
`

export const Title = styled.h1`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.title};
  color: ${vimovaTheme.colors.white};
  margin: 0 0 12px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.title} !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Subtitle = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 24px 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: rgba(255, 255, 255, 0.6) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OrangeDivider = styled.div`
  width: 60px;
  height: 3px;
  background: ${vimovaTheme.colors.orange};
  border-radius: 2px;
  margin-bottom: 32px;

  @media print {
    width: 60px !important;
    height: 3px !important;
    background: ${vimovaTheme.colors.orange} !important;
    border-radius: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SectionLabel = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 16px 0;

  @media print {
    font-size: 10px !important;
    color: rgba(255, 255, 255, 0.4) !important;
    letter-spacing: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px 20px;
  margin-bottom: 32px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    background: rgba(255, 255, 255, 0.06) !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px 20px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerPhoto = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;

  @media print {
    width: 48px !important;
    height: 48px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerPhotoFallback = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);

  @media print {
    width: 48px !important;
    height: 48px !important;
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.15) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 2px !important;
  }
`

export const BrokerName = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.white};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerTitle = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.orange};

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerContact = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: rgba(255, 255, 255, 0.6);

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: rgba(255, 255, 255, 0.6) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgencyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 32px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }
`

export const AgencyName = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.white};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgencyDetail = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: rgba(255, 255, 255, 0.6);

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: rgba(255, 255, 255, 0.6) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgencyWebsite = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.orange};

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DisclaimerText = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  margin: 0;
  max-width: 480px;

  @media print {
    font-size: 8px !important;
    color: rgba(255, 255, 255, 0.5) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BottomArea = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    margin-top: auto !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: flex-end !important;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  @media print {
    display: flex !important;
    align-items: flex-end !important;
  }
`

export const GreenBracketDecoration = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  opacity: 0.1;

  @media print {
    position: absolute !important;
    bottom: 20px !important;
    right: 20px !important;
    opacity: 0.1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
